export const FILTER_BUTTON_STYLES = {
  padding: '0.25rem 0.75rem',
  borderWidth: '1px',
  fontSize: '14px',
  fontWeight: '600',
}
